import { useCallback } from "react";

import { systemConstants } from "@shared/constants";

import { useDeviceType } from "@app/hooks/useDeviceType";

function useNavigationDeviceTypeCheck() {
  const { isMobile } = useDeviceType();

  const hasSupportForDeviceType = useCallback(
    (item: { supportedDeviceTypes?: string[] }) => {
      if (isMobile) {
        return item.supportedDeviceTypes?.includes(
          systemConstants.deviceType.mobile
        );
      }
      // TODO: add back later
      // if (isDesktop) {
      //   return item.supportedDeviceTypes?.includes(
      //     systemConstants.deviceType.desktop
      //   );
      // }
      return true;
    },
    [isMobile]
  );

  return {
    hasSupportForDeviceType
  };
}

export default useNavigationDeviceTypeCheck;
